// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__upHFg","search":"Settings_search__1KV3n","filter":"Settings_filter__101eK"};